// ============================================================
// CONFIGURAZIONE — modifica questa sezione
// ============================================================

// Nomi delle opzioni taglia (case-insensitive, sottostringa)
// Deve coprire tutte le lingue del negozio: il nome dell'opzione arriva
// tradotto (Taglia/Size/Größe/Talla/Taille/Maat/Tamanho/サイズ...)
const sizeOptionNames = ['taglia', 'size', 'misura', 'größe', 'groesse', 'talla', 'taille', 'maat', 'tamanho', 'サイズ'];

// Nazionalità: chiave = codice, valore = label UI
const nazionalita = {
  INT: 'INT',
  IT: 'IT',
  // UK: 'UK',
  FRBE: 'FR/BE',
  // DEATNLCHES: 'DE/AT/NL/CH/ES',
  DEATNLCHES: 'DE/AT/NL/ES',
  // USCA: 'US/CA',
  // MX: 'MX',
};

// Nazionalità di default (deve corrispondere a una chiave di `nazionalita`)
const defaultNazionalita = 'IT';

// Nazionalità nascoste nel selettore dei filtri (collezione/ricerca).
// Nel filtro le taglie numeriche convivono già con quelle letterali:
// convertire a INT creerebbe duplicati (es. "38" e "S" entrambi "S").
const nazionalitaEscluseFiltri = ['INT'];

// Taglie internazionali (letterali): i prodotti che le usano NON hanno
// il selettore nazionalità né conversione.
const taglieInternazionali = ['XXS', 'XS', 'S', 'SM', 'M', 'ML', 'L', 'LXL', 'XL', 'XXL', 'U'];

// Categorie prodotto (metafield custom.categories) escluse dal selettore,
// in tutte le lingue del negozio (case-insensitive).
const categorieEscluse = ['scarpe', 'shoes', 'schuhe', 'chaussures', 'zapatos', 'schoenen', 'sapatos', 'シューズ', '靴'];

// Tabella di conversione
// Chiave esterna: taglia Shopify (italiana, invariabile)
// Chiave interna: codice nazionalità
// Valore: taglia convertita da mostrare
const tabella = {
  34: { INT: 'XXS', IT: '34', UK: '2', FRBE: '32', DEATNLCHES: '30', USCA: '0', MX: '22' },
  36: { INT: 'XS', IT: '36', UK: '4', FRBE: '34', DEATNLCHES: '32', USCA: '2', MX: '24' },
  38: { INT: 'S', IT: '38', UK: '6', FRBE: '36', DEATNLCHES: '34', USCA: '4', MX: '26' },
  40: { INT: 'SM', IT: '40', UK: '8', FRBE: '38', DEATNLCHES: '36', USCA: '6', MX: '28' },
  42: { INT: 'M', IT: '42', UK: '10', FRBE: '40', DEATNLCHES: '38', USCA: '8', MX: '30' },
  44: { INT: 'ML', IT: '44', UK: '12', FRBE: '42', DEATNLCHES: '40', USCA: '10', MX: '32' },
  46: { INT: 'L', IT: '46', UK: '14', FRBE: '44', DEATNLCHES: '42', USCA: '12', MX: '34' },
  48: { INT: 'LXL', IT: '48', UK: '16', FRBE: '46', DEATNLCHES: '44', USCA: '14', MX: '36' },
  50: { INT: 'XL', IT: '50', UK: '18', FRBE: '48', DEATNLCHES: '46', USCA: '16', MX: '38' },
  52: { INT: 'XXL', IT: '52', UK: '20', FRBE: '50', DEATNLCHES: '48', USCA: '18', MX: '40' },
  
  'XXS': { INT: 'XXS', IT: '34', UK: '2', FRBE: '32', DEATNLCHES: '30', USCA: '0', MX: '22' },
  'XS': { INT: 'XS', IT: '36', UK: '4', FRBE: '34', DEATNLCHES: '32', USCA: '2', MX: '24' },
  'S': { INT: 'S', IT: '38', UK: '6', FRBE: '36', DEATNLCHES: '34', USCA: '4', MX: '26' },
  'SM': { INT: 'SM', IT: '40', UK: '8', FRBE: '38', DEATNLCHES: '36', USCA: '6', MX: '28' },
  'M': { INT: 'M', IT: '42', UK: '10', FRBE: '40', DEATNLCHES: '38', USCA: '8', MX: '30' },
  'ML': { INT: 'ML', IT: '44', UK: '12', FRBE: '42', DEATNLCHES: '40', USCA: '10', MX: '32' },
  'L': { INT: 'L', IT: '46', UK: '14', FRBE: '44', DEATNLCHES: '42', USCA: '12', MX: '34' },
  'LXL': { INT: 'LXL', IT: '48', UK: '16', FRBE: '46', DEATNLCHES: '44', USCA: '14', MX: '36' },
  'XL': { INT: 'XL', IT: '50', UK: '18', FRBE: '48', DEATNLCHES: '46', USCA: '16', MX: '38' },
  'XXL': { INT: 'XXL', IT: '52', UK: '20', FRBE: '50', DEATNLCHES: '48', USCA: '18', MX: '40' },
};

// ============================================================
// IMPLEMENTAZIONE
// ============================================================

const LS_KEY = 'mm-size-locale';

function getLocale() {
  const stored = localStorage.getItem(LS_KEY);
  return (stored && nazionalita[stored]) ? stored : defaultNazionalita;
}

function setLocale(locale) {
  localStorage.setItem(LS_KEY, locale);
}

// Locale effettiva nei filtri: se quella salvata non è disponibile nel
// selettore dei filtri (es. INT scelta in PDP), si ripiega sul default.
function getFilterLocale(locale) {
  return nazionalitaEscluseFiltri.includes(locale) ? defaultNazionalita : locale;
}

function convertSize(shopifyValue, locale) {
  const entry = tabella[shopifyValue];
  if (!entry || entry[locale] == null) return shopifyValue;
  return entry[locale];
}

function isSizeFieldset(fieldset) {
  const name = (fieldset.dataset.option || '').toLowerCase().trim();
  if (sizeOptionNames.some(n => name.includes(n))) return true;

  // Fallback indipendente dalla lingua: se la maggioranza dei valori
  // dell'opzione è presente nella tabella di conversione, è la taglia.
  const values = [...fieldset.querySelectorAll('.opt-btn')].map(input => input.value);
  if (values.length === 0) return false;
  const matches = values.filter(v => tabella[v] != null).length;
  return matches >= Math.ceil(values.length / 2);
}

// Prodotti esclusi dal selettore: taglie internazionali (letterali)
// o categoria esclusa (es. Scarpe, in qualsiasi lingua).
function isExcludedFieldset(fieldset) {
  const values = [...fieldset.querySelectorAll('.opt-btn')].map(input => input.value.toUpperCase().trim());
  if (values.length > 0) {
    const letterMatches = values.filter(v => taglieInternazionali.includes(v)).length;
    if (letterMatches >= Math.ceil(values.length / 2)) return true;
  }

  const picker = fieldset.closest('variant-picker');
  const cats = (picker && picker.dataset.mmCategories || '').toLowerCase();
  if (cats && categorieEscluse.some(c => cats.split('|').some(x => x.trim() === c))) return true;

  return false;
}

function updateFieldset(fieldset, locale) {
  fieldset.querySelectorAll('.opt-btn').forEach(input => {
    const label = document.querySelector(`label[for="${CSS.escape(input.id)}"] .js-value`);
    if (label) label.textContent = convertSize(input.value, locale);
  });
}

function updateAll(locale) {
  document.querySelectorAll('[data-selector-type="listed"]').forEach(fieldset => {
    if (isSizeFieldset(fieldset) && isExcludedFieldset(fieldset) == false) updateFieldset(fieldset, locale);
  });
  document.querySelectorAll('.filter-group').forEach(group => {
    if (isSizeFilterGroup(group)) updateFilterGroup(group, locale);
  });
}

// ============================================================
// Filtro taglie (faceted filters su collezione/ricerca)
// ============================================================

// Riconosce il gruppo filtro taglia dal param dell'input
// (es. "filter.v.option.taglia") o, in fallback, dai valori in tabella.
function isSizeFilterGroup(group) {
  const input = group.querySelector('.filter-group__checkbox');
  if (!input) return false;
  const param = (input.name || '').toLowerCase();
  if (param.indexOf('filter.v.option.') !== 0) return false;
  if (sizeOptionNames.some(n => param.includes(n))) return true;

  const values = [...group.querySelectorAll('.filter-group__checkbox')].map(i => i.value);
  const matches = values.filter(v => tabella[v] != null).length;
  return matches >= Math.ceil(values.length / 2);
}

// Converte solo il testo visibile: il value dell'input resta l'originale
// (è il parametro di filtro inviato a Shopify).
function updateFilterGroup(group, locale) {
  locale = getFilterLocale(locale);
  group.querySelectorAll('.filter-group__item').forEach(item => {
    const input = item.querySelector('.filter-group__checkbox');
    const textEl = item.querySelector('.filter-group__item__text');
    if (!input || !textEl) return;
    // Taglie internazionali letterali: nel filtro convivono con quelle
    // numeriche, ma non vanno tradotte.
    if (taglieInternazionali.includes(input.value.toUpperCase().trim())) return;
    let node = textEl.firstChild;
    while (node && node.nodeType !== 3) node = node.nextSibling;
    if (!node) return;
    const converted = convertSize(input.value, locale);
    // nodeValue (characterData): niente mutazioni childList, l'observer non rientra
    if (node.nodeValue.trim() !== converted) node.nodeValue = converted;
  });
}

function buildFilterSelector(group) {
  if (group.querySelector('.mm-locale-selector')) return;
  // Dentro il contenitore collassabile: si apre/chiude col gruppo.
  const target = group.querySelector('.toggle-target-container') || group.querySelector('.filter-group__items');
  if (!target) return;
  const wrapper = buildSelectorEl(nazionalitaEscluseFiltri);
  if (!wrapper) return;
  wrapper.classList.add('mm-locale-selector--filter');
  // Riga dedicata: il contenitore dei valori è flex-wrap, la pill da sola
  // occuperebbe una cella accanto alle taglie.
  const row = document.createElement('div');
  row.className = 'mm-locale-selector-row';
  row.appendChild(wrapper);
  target.prepend(row);
}

function initFilterGroup(group) {
  if (!isSizeFilterGroup(group)) return;
  buildFilterSelector(group);
  updateFilterGroup(group, getLocale());
}

// Evidenzia il bottone attivo in ogni selettore della pagina. Nei filtri
// la locale mostrata è quella effettiva (INT ripiega sul default).
function syncActiveButtons(locale) {
  document.querySelectorAll('.mm-locale-selector').forEach(selector => {
    const effective = selector.classList.contains('mm-locale-selector--filter') ? getFilterLocale(locale) : locale;
    selector.querySelectorAll('.mm-locale-btn').forEach(b => {
      b.classList.toggle('is-active', b.dataset.locale === effective);
    });
  });
}

// Crea il segmented control delle nazionalità. Il click aggiorna tutti i
// selettori .mm-locale-selector della pagina (PDP e filtri restano in sync).
// `exclude`: codici nazionalità da non mostrare in questo selettore.
function buildSelectorEl(exclude = []) {
  const locales = Object.keys(nazionalita).filter(l => !exclude.includes(l));
  if (locales.length < 2) return null;

  const current = exclude.length ? getFilterLocale(getLocale()) : getLocale();
  const wrapper = document.createElement('div');
  wrapper.className = 'mm-locale-selector';

  locales.forEach(locale => {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mm-locale-btn' + (locale === current ? ' is-active' : '');
    btn.dataset.locale = locale;
    btn.textContent = nazionalita[locale];
    btn.addEventListener('click', () => {
      setLocale(locale);
      updateAll(locale);
      syncActiveButtons(locale);
    });
    wrapper.appendChild(btn);
  });

  return wrapper;
}

function buildSelector(fieldset) {
  if (fieldset.querySelector('.mm-locale-selector')) return;
  const wrapper = buildSelectorEl();
  if (!wrapper) return;

  const legend = fieldset.querySelector('legend');
  if (legend) {
    const legendRow = legend.parentElement.classList.contains('flex') ? legend.parentElement : legend;
    legendRow.after(wrapper);
  } else {
    fieldset.prepend(wrapper);
  }
}

function initFieldset(fieldset) {
  if (!isSizeFieldset(fieldset)) return;
  if (isExcludedFieldset(fieldset)) return;
  buildSelector(fieldset);
  updateFieldset(fieldset, getLocale());
}

function init() {
  document.querySelectorAll('[data-selector-type="listed"]').forEach(initFieldset);
  document.querySelectorAll('.filter-group').forEach(initFilterGroup);
}

// Gestisce picker e filtri inseriti dinamicamente (quickbuy, ajax filtering, ecc.)
const observer = new MutationObserver(mutations => {
  mutations.forEach(({ addedNodes }) => {
    addedNodes.forEach(node => {
      if (node.nodeType !== 1) return;
      if (node.matches('[data-selector-type="listed"]')) {
        initFieldset(node);
      } else if (node.matches('.filter-group')) {
        initFilterGroup(node);
      } else {
        node.querySelectorAll('[data-selector-type="listed"]').forEach(initFieldset);
        node.querySelectorAll('.filter-group').forEach(initFilterGroup);
      }
    });
  });
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    init();
    observer.observe(document.body, { childList: true, subtree: true });
  });
} else {
  init();
  observer.observe(document.body, { childList: true, subtree: true });
}
